import { render, staticRenderFns } from "./DownLicense.vue?vue&type=template&id=f23b85cc&scoped=true&"
import script from "./DownLicense.vue?vue&type=script&lang=js&"
export * from "./DownLicense.vue?vue&type=script&lang=js&"
import style0 from "./DownLicense.vue?vue&type=style&index=0&id=f23b85cc&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23b85cc",
  null
  
)

export default component.exports